import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'kangarootime-ui';
import './ListItem.css';

const ListItem = ({
  isActive,
  showBadge,
  messageCount,
  ...props
}) => {
  const hasNewMessages = messageCount > 0;

  return (
    <li
      {...props}
      className='messages-list-item'
      style={{ backgroundColor: isActive && '#FFFFFF' }}
    >
      <span
        className='messages-list-item-text'
        style={{
          color: hasNewMessages && '#FFFFFF',
          fontWeight: hasNewMessages && 700
        }}
      >
        { props.children }
      </span>
      { showBadge && hasNewMessages &&
        <Badge
          size={16}
          count={messageCount}
          style={{ alignSelf: 'center' }}
        />
      }
    </li>
  );
};

ListItem.propTypes = {
  isActive: PropTypes.bool,
  showBadge: PropTypes.bool,
  messageCount: PropTypes.number
};

ListItem.defaultProps = {
  isActive: false,
  showBadge: false,
  messageCount: 0
};

export default ListItem;
